import { Group, Text, Button, Box, Grid, Flex, ActionIcon, Modal, Space, Select, Input, CopyButton, Switch, Skeleton } from '@mantine/core';
import { IconPencil, IconTrash, IconCheck, IconX, IconCaretUpFilled, IconCaretDownFilled, IconSearch } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { modals } from '@mantine/modals';
import { useNavigate } from "react-router-dom";
import { notifications } from '@mantine/notifications';
import SettingsApi from "../../../api/SettingsApi";
import { HelpTip } from "../../GeneralComponent/GeneralComponent";

export function ManageYourPostbacks({ SelectMemberWebsiteListValue, SelectMemberWebsiteListOnChange }:any) {

  const [addPostbackOpened, setAddPostback] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const [AffiliateLinkParam, setAffiliateLinkParam] = useState('');

  const [AffiliateLinkURL, setAffiliateLinkURL] = useState('');


  const navigate = useNavigate();
  const [postbackList, setPostbackList] = useState([]);
  const [affiliateNetworkList, setAffiliateNetworkList] = useState([]);
  const [funnelPageList, setFunnelPageList] = useState([]);

  const [FunnelPageValue, setFunnelPage] = useState('');
  const [LandingPageValue, setLandingPage] = useState('');

  const [AffiliateNetworkValue, setAffiliateNetworkValue] = useState('');
  const [PostbackNameValue, setPostbackNameValue] = useState('');

  const [recordUniqueConversionchecked, setRecordUniqueConversionchecked] = useState(0);
  const [PostbackUpdateId, setPostbackUpdateId] = useState('');

  const [FunnelIdValue, setFunnelIdValue] = useState('');
  const [PostbackUrlValue, setPostbackUrlValue] = useState('');
  const [funnelList, setfunnelList] = useState([]);
  const [NetworkValue, setNetwork] = useState('');
  const [NetworkText, setNetworkText] = useState('');
  const [AffiliateUrlValue, setAffiliateUrl] = useState('https://');
  const [marksalestime, setMarksalestime] = useState(0);

  const [showSkeleton, setShowSkeleton] = useState(false);

  const [sortKeyName, setSortKeyName] = useState('');
  const [sortingDirection, setSortingDirection] = useState('');
  const [sortedPostbackList, setSortedPostbackList] = useState([]);
  const [isSavingPostback, setIsSavingPostback] = useState(false);
  const [pendingNewPostbackLookup, setPendingNewPostbackLookup] = useState<any>(null);

  const handleFunnelPageChange = (value:any) => {
    setFunnelPage(value);
  }

  const handleLandingPageChange = (value:any) => {
    setLandingPage(value);
  }

  const handleNetworkChange = (selectedValue) => {
  const selectedNetwork = affiliateNetworkList.find(network => network.value === selectedValue);
  setNetwork(selectedValue);
  setNetworkText(selectedNetwork.label);
  setAffiliateLinkParam('');
  setAffiliateLinkURL('');
};


  const handleSwitchChange = (event) => {
    const isChecked = event.currentTarget.checked;
    setRecordUniqueConversionchecked(isChecked ? 1 : 0);
  };

  const handleUpdateAffiliateLink = () => {
    SettingsApi.generataffiliatenetworkurl({
      network_value: NetworkValue,
      affiliate_url: AffiliateUrlValue
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if (data.status === 1) {
        setAffiliateLinkParam(data.data); 
        let myArr = AffiliateUrlValue.split("?");
        if (myArr.length > 1) {
          let myArrparam = data.data.split("?");
          if (myArrparam.length > 1) {
            let param = data.data.replace("?", "&");
            if (AffiliateUrlValue.slice(-1) === '/' && data.data.slice(0, 1) === '/') {
              param = data.data.replace("/", "");
              setAffiliateLinkURL(AffiliateUrlValue + param);
            } else {
              setAffiliateLinkURL(AffiliateUrlValue + param);
            }
           }else {
            if (AffiliateUrlValue.slice(-1) === '/' && data.data.slice(0, 1) === '/') {
              data.data = data.data.replace("/", "");
              setAffiliateLinkURL(AffiliateUrlValue + data.data);
            } else {
              setAffiliateLinkURL(AffiliateUrlValue + data.data);
            }
          }

        } else {
          let param = data.data.replace("&", "?");
          if (AffiliateUrlValue.slice(-1) === '/' && data.data.slice(0, 1) === '/') {
            param = data.data.replace("/", "");
            setAffiliateLinkURL(AffiliateUrlValue + param);
          } else {
            setAffiliateLinkURL(AffiliateUrlValue + param);
          }
        }
      } else {
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
      }
    })
    .catch(error => {
      console.error("API Error:", error);
    });
  }

  const handleAffiliateNetworkChange = (value:any) => {
    setAffiliateNetworkValue(value);
  }

  const closePostbackModal = () => {
    setAddPostback(false);
    setFunnelPage('');
    setLandingPage('');
    setAffiliateNetworkValue('');
    setPostbackNameValue('');
    setFunnelIdValue('');
    setAffiliateLinkParam('');
    setPostbackUrlValue('');
    setNetwork('');
    setNetworkText('');
    setAffiliateUrl('https://');
    setAffiliateLinkURL('');
    setPostbackUpdateId('');
    setIsSavingPostback(false);
    setPendingNewPostbackLookup(null);
    setIsEditMode(false);
  }

  const handleAddPostbackSubmit = (e:any) => {
    e.preventDefault();
    if (isSavingPostback) return;
    const isNewSubmission = !PostbackUpdateId;
    const lookupCriteria = {
      postback_name: PostbackNameValue,
      funnel_id: FunnelPageValue,
      page_id: LandingPageValue,
    };
    setIsSavingPostback(true);
    SettingsApi.saveupdatepostback({
      funnel_page: FunnelPageValue,
      landing_page:LandingPageValue,
      affiliate_network:AffiliateNetworkValue,
      postback_name:PostbackNameValue,
      sales_conversion: recordUniqueConversionchecked,
      postback_id: PostbackUpdateId ? PostbackUpdateId : '',
      network: NetworkValue,
      network_affiliate_url: AffiliateUrlValue,
      affiliate_link_param: AffiliateLinkParam,
      affiliate_link_url: AffiliateLinkURL,
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        notifications.show({
          color: 'green',
          icon: <IconCheck size="1.1rem" />,
          title: 'Success',
          message: data.message,
        });
        setMarksalestime(data.data.updated_time);
        setPostbackUrlValue(data.data.postback_url);
        if (isNewSubmission) {
          setPendingNewPostbackLookup(lookupCriteria);
          setIsEditMode(true);
        }
      }else{
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
      }
      setIsSavingPostback(false);
    })
    .catch(error => {
      console.error("API Error:", error);
      setIsSavingPostback(false);
    });
  };

  /* After a new postback is saved, the postback list refetches via marksalestime.
     Match the new row by name+funnel+page so subsequent saves become updates instead of duplicate inserts. */
  useEffect(() => {
    if (pendingNewPostbackLookup && sortedPostbackList.length > 0) {
      const match = sortedPostbackList.find((p:any) =>
        p.postback_name === pendingNewPostbackLookup.postback_name &&
        p.funnel_id === pendingNewPostbackLookup.funnel_id &&
        p.page_id === pendingNewPostbackLookup.page_id
      );
      if (match) {
        setPostbackUpdateId(match.postback_id);
        setPendingNewPostbackLookup(null);
      }
    }
  }, [sortedPostbackList, pendingNewPostbackLookup]);


  const updatePostback = (UpdatePostbackId:any,funnelId:any) => {
    setPostbackUpdateId(UpdatePostbackId);
    setIsEditMode(true);
    setAddPostback(true);
    SettingsApi.getsinglepostback({
      postback_id: UpdatePostbackId
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        setAffiliateNetworkValue(data.data.affiliate_network);
        setPostbackNameValue(data.data.name);
        setFunnelIdValue(data.data.funnel_id);
        setLandingPage(data.data.page_id);
        setPostbackUrlValue(data.data.postback_url);
        setNetwork(data.data.network);
        setAffiliateUrl(data.data.network_affiliate_url);
        setAffiliateLinkParam(data.data.affiliate_link_param);
        setAffiliateLinkURL(data.data.affiliate_link_url);
      }else{
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
      }
    })
    .catch(error => {
      console.error("API Error:", error);
    });

    SettingsApi.getfunnelpagelistbyfunnelid({
      funnel_id: funnelId
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        setFunnelPageList(data.data);
      }else{
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
      }
    })
    .catch(error => {
      console.error("API Error:", error);
    });
  }

  useEffect(() => {
    if(FunnelIdValue !== '' && SelectMemberWebsiteListValue !== ''){
      SettingsApi.getfunnellist({
        system_website_id: SelectMemberWebsiteListValue
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setfunnelList(data.data);
          if(data.data.length > 0){
            var i;
            for(i = 0; i <data.data.length; i++){
              if(data.data[i].funnel_id === FunnelIdValue){
                setFunnelPage(data.data[i].funnel_id);
                break;
              }
            }
          }else{
            setFunnelPage('');
          }
        }
      })
      .catch(error => {
        console.log(error);
      });
    }
  }, [FunnelIdValue, SelectMemberWebsiteListValue, navigate]);

  const handlePostbackDelete = (deletePostbackId:any,deletePageId:any) => {
    setShowSkeleton(true);
    SettingsApi.deletepostback({
      postback_id: deletePostbackId,
      landing_page: deletePageId,
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
          setShowSkeleton(false);
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        notifications.show({
          color: 'green',
          icon: <IconCheck size="1.1rem" />,
          title: 'Success',
          message: data.message,
        });
        setMarksalestime(data.updated_time);
        setShowSkeleton(false);
      }
    })
    .catch(error => {
      console.log(error);
      setShowSkeleton(false);
    });
  }

  const deletePostbackConfirm = (deletePostbackId:any,deletePageId:any) => modals.openConfirmModal({
    trapFocus: false,
    title: 'Please confirm your action',
    children: (
      <Text size="sm">
        Are you sure you want to delete this Postbacks?
      </Text>
    ),
    labels: { confirm: 'Confirm', cancel: 'Cancel' },
    onCancel: () => console.log('Cancel'),
    onConfirm: () => handlePostbackDelete(deletePostbackId,deletePageId),
  });
  
  useEffect(() => {
    if(SelectMemberWebsiteListValue !== ''){
      setShowSkeleton(true);
      SettingsApi.getpostbacklist({
        system_website_id: SelectMemberWebsiteListValue
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
            setShowSkeleton(false);
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setPostbackList(data.data);
          setSortedPostbackList(data.data);
          setShowSkeleton(false);
        }else{
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: data.message,
          });
          setShowSkeleton(false);
        }
      })
      .catch(error => {
        console.error("API Error:", error);
        setShowSkeleton(false);
      });

      SettingsApi.getaffiliatenetworklist()
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          const formattedData = Object.entries(data.data).map(([value, label]) => ({ value, label }));
          setAffiliateNetworkList(formattedData);
        }else{
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: data.message,
          });
        }
      })
      .catch(error => {
        console.error("API Error:", error);
      });

      SettingsApi.getfunnellist({
        system_website_id: SelectMemberWebsiteListValue
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setfunnelList(data.data);
        }
      })
      .catch(error => {
        console.log(error);
      });

      if(FunnelPageValue !== ''){
        SettingsApi.getfunnelpagelistbyfunnelid({
          funnel_id: FunnelPageValue
        })
        .then(response => {
          if (response.ok) {
            return response.json();
          } else {
            if (response.status === 401 || response.status === 400) {
              navigate("/logout");
            }
          }
        })
        .then(data => {
          if(data.status === 1){
            setFunnelPageList(data.data);
          }else{
            notifications.show({
              color: 'red',
              icon: <IconX size="1.1rem" />,
              title: 'Error',
              message: data.message,
            });
          }
        })
        .catch(error => {
          console.error("API Error:", error);
        });
      }
    }
  }, [SelectMemberWebsiteListValue,marksalestime,navigate,FunnelPageValue]);


  const handleSorting = (keyName: string) => {
    let newDirection = sortingDirection === 'desc' ? 'asc' : 'desc';
    setSortingDirection(newDirection);
    setSortKeyName(keyName);
    
    const sortedList = [...postbackList].sort((a, b) => {
      if (!keyName) return 0;

      const valueA = a[keyName]?.toString().toLowerCase() || '';
      const valueB = b[keyName]?.toString().toLowerCase() || '';

      if (valueA < valueB) return newDirection === 'asc' ? -1 : 1;
      if (valueA > valueB) return newDirection === 'asc' ? 1 : -1;
      return 0;
    });
    setSortedPostbackList(sortedList);
  };

  const handleKeywordChange = (e) => {
    const keyword = e.target.value;

    const filteredList = postbackList.filter(data =>
      data.postback_name?.toLowerCase().includes(keyword.toLowerCase())
    );

    setSortedPostbackList(filteredList);
  };

  return (
    <>
      <Modal.Root size={1100} opened={addPostbackOpened} onClose={closePostbackModal} trapFocus={false}>
        <Modal.Overlay />
        <Modal.Content>
          <Modal.Header>
            <Modal.Title><Text weight={500}>POSTBACKS URL BUILDER <HelpTip helpId={354} /></Text></Modal.Title>
            <Modal.CloseButton />
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleAddPostbackSubmit}>
              <Group mb={10}>
                <Box
                  mt={10}
                  sx={(theme) => ({
                    backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : "#f8f9fa",
                    padding: "10px",
                    borderRadius: "4px"
                  })}
                >
                  <Text weight={500}>Don't have direct access to a Thank You Page?</Text>
                  <Space h="xs" />
                  <Text>Postback URL's allow you to get accurate conversion data sent direct from your affiliate network or any server that allows Postbacks.</Text>
                </Box>
              </Group>
              <Grid>
                <Grid.Col span={2}>
                  <Text>Select a Funnel:</Text>
                </Grid.Col>
                <Grid.Col span={2}>
                  <Select
                    data={[
                      { value: '', label: 'Select Funnel', disabled: true },
                      ...funnelList.map(option => ({
                        value: option.funnel_id,
                        label: option.funnel_name
                      }))
                    ]}
                    w={250}
                    value={FunnelPageValue}
                    name="funnel_page"
                    onChange={handleFunnelPageChange}
                    disabled={isEditMode}
                  />
                </Grid.Col>
              </Grid>
              <Grid mb={10}>
                <Grid.Col span={2}>
                  <Text>Select a Landing Page:</Text>
                </Grid.Col>
                <Grid.Col span={2}>
                  <Select
                    data={[
                      { value: '', label: 'Select Page', disabled: true },
                      ...funnelPageList.map(option => ({
                        value: option.page_id,
                        label: option.title
                      }))
                    ]}
                    w={250}
                    value={LandingPageValue}
                    name="landing_page"
                    onChange={handleLandingPageChange}
                    disabled={isEditMode}
                  />
                </Grid.Col>
              </Grid>
              <Text mb={10}>Simply follow these 3 simple steps:</Text>
              <Group mb={10}>
                <Text weight={500}>1.</Text><Text>Create Your Affiliate / Offer link below:</Text>
              </Group>
              <Group mb={10} ml={20}>
                <Box
                  mt={10}
                  sx={(theme) => ({
                    backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : "#f8f9fa",
                    padding: "10px",
                    borderRadius: "4px"
                  })}
                >
                  <Text>Postback URLs allow you to accurately track your affiliate sales, upsells, downsells and refunds with a simple 2-step process. The first step is to pass a unique tracking ID to your affiliate links.</Text>
                  <Space h="xs" />
                  <Text>Just use this simple form and we'll show you exactly how to do that. If your affiliate network isn't listed, please see What if my affiliate network isn't listed?</Text>
                </Box>
              </Group>
              <Grid>
                <Grid.Col span={2} ml={20}>
                  <Text>Select Network:</Text>
                </Grid.Col>
                <Grid.Col span={2}>
                  <Select
                    data={affiliateNetworkList}
                    value={NetworkValue}
                    name="network"
                    w={200}
                    onChange={handleNetworkChange}
                  />
                </Grid.Col>
              </Grid>
              <Grid mb={10}>
                <Grid.Col span={2} ml={20}>
                  <Text>Select Link:</Text>
                </Grid.Col>
                <Grid.Col span={2}>
                  <Input
                    w={200}
                    name="affiliate_url"
                    onChange={(event) => setAffiliateUrl(event.currentTarget.value)}
                    value={AffiliateUrlValue}
                  />
                </Grid.Col>
              </Grid>
              <Button ml={20} mb={10} onClick={handleUpdateAffiliateLink}>
                Update My Affiliate Link
              </Button>
              {AffiliateLinkURL && <div>
                <Text ml={20}>{NetworkText ? NetworkText : NetworkValue} it is, Here you go...</Text>
                <Group>
                  <Text ml={20} mb={10} mt={10}>To pass the correct tracking ID to your affiliate link, just add this to the end of your link so it looks like the URL below.</Text>
                  <Input
                    variant="filled"
                    value={AffiliateLinkParam}
                  />
                </Group>
                <Group ml={20} mb={10}>
                  <Input
                    variant="filled"
                    value={AffiliateLinkURL}
                    w={500}
                  />
                  <CopyButton value={AffiliateLinkURL}>
                    {({ copied, copy }) => (
                      <Button color={copied ? 'teal' : 'blue'} onClick={copy}>
                        {copied ? 'Copied url' : 'Copy url'}
                      </Button>
                    )}
                  </CopyButton>
                </Group>
              </div>}
              <Text ml={20} mb={10}>Next, we will create our Postback URL:</Text>
              <Group mb={10}>
                <Text weight={500}>2.</Text><Text>Select your affiliate network:</Text>
                <Select
                  data={affiliateNetworkList}
                  value={AffiliateNetworkValue}
                  name="affiliate_network"
                  onChange={handleAffiliateNetworkChange}
                />
              </Group>
              <Group mb={10}>
                <Text weight={500}>3.</Text><Text>Record unique conversion only : </Text>
                <Switch 
                  checked={recordUniqueConversionchecked === 1} 
                  onChange={handleSwitchChange} 
                />
              </Group>
              <Group mb={10}>
                <Text weight={500}>4.</Text><Text>Enter Postback Name: </Text>
                <Input
                  name="postback_name"
                  onChange={(event) => setPostbackNameValue(event.currentTarget.value)}
                  value={PostbackNameValue}
                />
              </Group>
              {PostbackUrlValue !== '' && (
                <Group mb={10}>
                  <Text weight={500}>5.</Text><Text>Copy the generated Postback url below, and paste it to the selected affiliate site or server: <br/>{PostbackUrlValue}</Text>
                  <CopyButton value={PostbackUrlValue}>
                    {({ copied, copy }) => (
                      <Button color={copied ? 'teal' : 'blue'} onClick={copy}>
                        {copied ? 'Copied url' : 'Copy url'}
                      </Button>
                    )}
                  </CopyButton>
                </Group>
              )}
              <Group mb={10}>
                <Button type="submit" loading={isSavingPostback} disabled={isSavingPostback}>
                  {PostbackUrlValue !== '' ? 'Update & generate Postback url' : 'Save & generate Postback url'}
                </Button>
                <Button color="red" onClick={closePostbackModal}>
                  Close
                </Button>
              </Group>
            </form>
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>
      <Group position="apart" mb="xs">
        <Text weight={500}>MANAGE YOUR POSTBACKS <HelpTip helpId={290} /></Text>
      </Group>
      <Button onClick={() => {
        closePostbackModal();
        setIsEditMode(false);
        setAddPostback(true);
      }}>
        Add a New Postback
      </Button>
      {postbackList.length > 0 && (
        <Box
          p={4}
          pl={20}
          mt={10}
          sx={(theme) => ({
            padding: "10px",
            borderRadius: theme.radius.md,
            fontWeight: "bold",
          })}
        >
        {postbackList.some(item => Array.isArray(item) ? item.length > 0 : true) && (
          <Grid gutter="xs">
            <Grid.Col span={3}>
              <Text mt={3} weight={500} onClick={() => handleSorting('postback_name')}>
                <span style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }}>
                  {'Postback Name'}
                  {sortKeyName === 'postback_name' && (
                    sortingDirection === 'asc' ? <IconCaretUpFilled /> : <IconCaretDownFilled />
                  )}
                </span>
              </Text>
            </Grid.Col>
            <Grid.Col span={3}>
              <Text mt={3} weight={500} onClick={() => handleSorting('page_name')}>
                <span style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }}>
                  {'Page Name'}
                  {sortKeyName === 'page_name' && (
                    sortingDirection === 'asc' ? <IconCaretUpFilled /> : <IconCaretDownFilled />
                  )}
                </span>
              </Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Input icon={<IconSearch size={16} />} 
                  placeholder="Search"
                  maxLength={50}
                  autoFocus
                  onChange={handleKeywordChange}
                  style={{ maxWidth: "250px" }}
                />
              </div>
            </Grid.Col>
          </Grid>
        )}
        </Box>
      )}
      {showSkeleton ? (
        <Flex direction="column" gap="sm" mt={10}>
          {Array.from({ length: 12 }).map((_, index) => (
            <Skeleton key={index} height={44} width={1262} />
          ))}
        </Flex>
      ) : (
        sortedPostbackList.map((item,index) => (
          <Box
           key={index}
            p={4}
            pl={20}
            mt={10}
            sx={(theme) => ({
              backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : '#f8f9fa',
              padding: "10px",
              borderRadius: theme.radius.md,
              border: "0.0625rem solid transparent",
              borderColor: theme.colorScheme === 'dark' ? theme.colors.dark[1] : '#dee2e6'
            })}
          >
            <Grid gutter="xs">
              <Grid.Col span={3}>
                <Text mt={3}>
                  {item.postback_name}
                </Text>
              </Grid.Col>
              <Grid.Col span={3}>
                <Text mt={3}>
                  {item.page_name}
                </Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Flex
                  justify="flex-end"
                  align="center"
                  direction="row"
                  wrap="wrap"
                  gap={2}
                >
                  <ActionIcon
                    variant="default"
                    size="lg"
                    mx={3}
                    title="Edit"
                    onClick={() => updatePostback(item.postback_id, item.funnel_id)}
                  >
                    <IconPencil size="1.1rem" />
                  </ActionIcon>
                  <ActionIcon
                    variant="default"
                    size="lg"
                    mx={3}
                    title="Delete"
                    onClick={() => deletePostbackConfirm(item.postback_id, item.page_id)}
                  >
                    <IconTrash size="1.1rem" />
                  </ActionIcon>
                </Flex>
              </Grid.Col>
            </Grid>
          </Box>
        ))
      )}
    </>
  );
}